export default __webpack_public_path__ + "static/media/Explain.36d5b388.webm";